import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import { QueryLoading } from 'modules/common/components/QueryLoading';
import { ROOT_PATH } from 'modules/common/const';
import { createRouteConfig } from 'modules/common/utils/createRouteConfig';

const PATH = `${ROOT_PATH}withdrawal/`;

export const withdrawalRouteConfig = createRouteConfig(
  {
    main: {
      path: PATH,
      generatePath: () => {
        return PATH;
      },
    },
  },
  PATH,
);

const Withdrawal = lazy(() =>
  import('./screens/Withdrawal').then(({ Withdrawal }) => ({
    default: Withdrawal,
  })),
);

export function getWithdrawalRoutes(): JSX.Element {
  return (
    <>
      <Route
        element={
          <Suspense fallback={<QueryLoading isAbsolute />}>
            <Withdrawal />
          </Suspense>
        }
        path={withdrawalRouteConfig.main.path}
      />
    </>
  );
}
